export abstract class BasePlugin {
  public abstract onConnected(editor: any, firepadRef: any): void;
  public abstract onDisconnected(editor: any, firepadRef: any): void;
  public abstract getMenuBarComponent(): () => JSX.Element;
}
